import React, {Component} from 'react';
import PropTypes from 'prop-types';

import PulsingLinesThrobber from "../../Common/components/PulsingLinesThrobber";
import {loadGroupReviews} from "../../ReduxStore/ProductGroupPage/groupReviewsSlice";
import {getDispatch} from "../../Utility/ReduxHelper";

export default function ReviewLoaderUI({
  initialCount = 10,
  scope = {},
  reviewsLoaded = 0,
  reviewSummary = {},
  ProductReviews = {},
  loading = false,
  nextOffset = null,
  dispatch
}) {

  // callback, invoked when user clicks link.
  // Invoke /reviews/list?group_id=... which will update the reviews store.
  function loadMoreReviews(e) {
    e?.preventDefault();

    dispatch ||= getDispatch();

    // console.log("ReviewLoaderUI - loadMoreReviews()...");

    let offset = nextOffset ? nextOffset :
      ((+initialCount) + (+reviewsLoaded));

    let payload = {
      params: Object.assign({}, scope, {offset})
    }

    dispatch(loadGroupReviews(payload));
  }

  function getVisibleCount() {
    // console.log("GET VISIBLE COUNT" + JSON.stringify(this.props, null, 2));

    if (nextOffset && nextOffset > 0) return nextOffset;

    // console.log(`init ${this.props.initial_count} off ${count}`);
    return (+initialCount) + (+reviewsLoaded);
  }

  let count = getVisibleCount();
  let max = reviewSummary?.count || 0;
  if (count >= max) return null;

  return <div className="review-loader">
    <div className="see-all-reviews"><p>
      <a href="#" onClick={loadMoreReviews}>
        {'See Next '}
        <strong>10</strong>
        {' of '}
        <strong>{max}</strong>
        {' reviews. '}
      </a>
    </p></div>

    {loading && <PulsingLinesThrobber/>}
  </div>
}

ReviewLoaderUI.propTypes = {
  reviewSummary: PropTypes.object,
  initialCount: PropTypes.number,
  // "scope" is limiting params for the reload request to the back-end.
  //
  // {vehicle_id: 2083273, product_id: null, group_id: 2856}
  scope: PropTypes.shape({
    vehicle_id: PropTypes.number,
    product_id: PropTypes.number,
    group_id: PropTypes.number
  })
}
